// Converts numeric degrees to radians
export const toRad = (value) => {
  return (value * Math.PI) / 180;
};
